var _effectorFileName = "/builds/gmini/front-ui-kit/src/Select/Select.tsx";
import { useEffect } from 'react';
import { SelectInputWrapperExtraStyled } from './Select.styled';
import { useSelectHandlers, useSelectVariables } from './hooks';
import { RenderOptions, Popover, Input } from './components';
import { HEIGHT_SELECT_INPUT, MAX_HEIGHT_SELECT_POPOVER } from './constants'; // eslint-disable-next-line @typescript-eslint/ban-types

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Select = props => {
  const {
    value,
    autofocus,
    colorScheme = 'grey',
    options,
    disabled,
    loading,
    getOptionLabel,
    emptyOptionListMessage,
    onInputChange,
    optionListStyles,
    renderOption,
    onScrollList,
    allowDelete = true,
    popoverBoxShadow,
    optionListStyled,
    onBlur,
    optionDataTestIdPrefix,
    dataTestIdFor,
    ...inputProps
  } = props;
  const variables = useSelectVariables(props);
  const {
    anchorEl,
    focused,
    inputRef,
    inputValue,
    setAnchorEl
  } = variables;
  const handlers = useSelectHandlers({
    variables,
    onBlur,
    ...props
  });
  const {
    onChangeInputValue,
    onFocus,
    onKeyDown,
    onResetSelectInput,
    renderSelectInputValue,
    onBlurHandler
  } = handlers;
  useEffect(() => {
    if (autofocus) {
      setAnchorEl(inputRef.current);
    }
  }, [autofocus, inputRef, setAnchorEl]);
  useEffect(() => {
    onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(inputValue);
  }, [inputValue, onInputChange]);
  const id = anchorEl ? 'simple-popover' : undefined;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Input, { ...inputProps,
      value: inputValue,
      selectValue: value,
      onChange: onChangeInputValue,
      colorScheme: colorScheme,
      focused: focused,
      onFocus: onFocus,
      autoFocus: autofocus,
      disabled: disabled,
      onKeyDown: onKeyDown,
      renderInputValue: renderSelectInputValue,
      onReset: onResetSelectInput,
      arrowIconIsTurned: Boolean(anchorEl),
      resettable: allowDelete,
      wrapperStyled: SelectInputWrapperExtraStyled,
      "aria-describedby": id,
      dataTestIdFor: {
        input: dataTestIdFor === null || dataTestIdFor === void 0 ? void 0 : dataTestIdFor.input
      },
      ref: inputRef
    }), /*#__PURE__*/_jsx(Popover, {
      onClose: onBlurHandler,
      anchorEl: anchorEl,
      paperStyles: {
        boxShadow: popoverBoxShadow
      },
      inputRef: inputRef,
      heightSelectPx: HEIGHT_SELECT_INPUT,
      maxHeight: MAX_HEIGHT_SELECT_POPOVER,
      onScroll: onScrollList,
      contentStyles: optionListStyles,
      contentStyled: optionListStyled,
      children: /*#__PURE__*/_jsx(RenderOptions, { ...props,
        ...handlers,
        ...variables
      })
    })]
  });
};